import { render, staticRenderFns } from "./useInfo.vue?vue&type=template&id=30828d7e&scoped=true"
import script from "./useInfo.vue?vue&type=script&lang=js"
export * from "./useInfo.vue?vue&type=script&lang=js"
import style0 from "./useInfo.vue?vue&type=style&index=0&id=30828d7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30828d7e",
  null
  
)

export default component.exports